import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

export interface AmenitySlot {
  price: number | string
  [key: string]: unknown
}

export interface AmenityLocation {
  id: number
  name: string
}

export interface AmenityListItem {
  id: number
  buildingId: number
  name: string
  description: string
  image: string | null
  hidden: boolean
  multiDayBooking: boolean
  locations: AmenityLocation[]
  hourlySlots: AmenitySlot[]
  multidaySlots: AmenitySlot[]
  createdAt: number
}

export const USE_GET_AMENITIES_QUERY_KEY = 'useGetAmenitiesList'

export const getAmenitiesQueryKey = (buildingId?: number) => [
  USE_GET_AMENITIES_QUERY_KEY,
  buildingId,
]

export const getAmenities = async (buildingId: number) => {
  const response = await authAPI.get<AmenityListItem[]>(`/amenity/${buildingId}`)
  return response.data
}

export const useGetAmenities = (buildingId?: number) =>
  useQuery({
    enabled: !!buildingId,
    placeholderData: keepPreviousData,
    queryFn: () => getAmenities(buildingId as number),
    queryKey: getAmenitiesQueryKey(buildingId),
  })
